import {
    Button,
    Box,
    Flex,
    Stack,
    Text,
    Input,
    FormControl,
    FormLabel,
    FormErrorMessage,
    chakra,
    useToast,
    useColorModeValue,
} from "@chakra-ui/react";

import { Form, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { useEvoContext } from "../../context/evo.context";
import { ScreenContainer } from "../container/ScreenContainer";
import { Header as Nav } from "../header/Header";
import { Footer } from "../footer/Footer";
import {ROUTE_LOGIN, ROUTE_MAIN, ROUTE_PROFILE} from "../../App";
import getFormValues from "../forms/values/formValues";
import {fieldNameAndLabels} from "../../infrastructure/utils/formUtils";
import formValidator from "../forms/validate/validate";
import PasswordResetDataProvider from "../dataProviderEvo/password-reset-data-provider";
import PasswordChangeDataProvider from "../dataProviderEvo/password-change-data-provider";

export default function PasswordChange() {
    const { isLoggedIn, userId } = useEvoContext();
    const navigate = useNavigate();

    const formRef = useRef(null);
    const toast = useToast();

    const [formData, setFormData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!isLoggedIn) {
            navigate(ROUTE_LOGIN);
        }
    }, [isLoggedIn, navigate]);

    let currentPwdLabel = 'Aktuální heslo';

    const validateForm = () => {


        const form = formRef.current;
        if (form) {

            const currentFormData = getFormValues(form);

            const { isValid, validationErrors} = formValidator(currentFormData, fieldNameAndLabels);

            let isValidVar = isValid;

            if (!formData.currentPassword) {
                validationErrors.currentPassword = 'Vyplňte ' + currentPwdLabel;
            }

            if (isValid && formData.password !== formData.confirmPassword) {
                isValidVar = false;
                validationErrors.confirmPassword = "Hesla se neshodují.";
            }

            setErrors(validationErrors);

            if (isValidVar) {
                return true;
            }
        }
        return false;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {

            let headers = {
                "user": userId,
                "oldpassword": formData.currentPassword,
                "newpassword": formData.password,
            }

            let params = headers;

            let dp = new PasswordChangeDataProvider();
            dp.change(params, headers).then((res) => {

                if (res.status === 'OK') {
                    toast({
                        description: res.messages[0],
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });

                    navigate(ROUTE_MAIN + ROUTE_PROFILE);

                } else {

                    toast({
                        description: res.errors[0],
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }
            });
        }
    };

    useEffect(() => {

        toast.closeAll();

        if (Object.keys(errors).length > 0) {

            const errorList = Object.values(errors).map((error, index) => (
                <li key={index}>{error}</li>
            ));

            // const errorMessage = Object.values(errors).join('\n');
            toast({
                title: 'Prosíme vyplňte povinné údaje',
                description: (
                    <Box as="ul" ml={4}>
                        {errorList}
                    </Box>
                ),
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: "top"
            });
        }

    }, [errors]);

    return (
        <Box bg={useColorModeValue("#f9f9f9", "#1a202c")}>
            <Nav />
            <ScreenContainer mb={"250px"}>
                <Flex flex={1} align={"center"} justify={"center"}>
                    <Stack spacing={6} w={"full"}>
                        <chakra.h1 textAlign={"center"} fontSize={"4xl"} py={10} fontWeight={"bold"}>
                            {"Změnit heslo"}
                        </chakra.h1>

                        <Box bg={"white"} p={10} boxShadow={"md"} borderRadius={10}>
                            <Form ref={formRef} onSubmit={handleSubmit}>
                                <FormControl isInvalid={errors.currentPassword} mb={4}>
                                    <FormLabel htmlFor="currentPassword">{currentPwdLabel}</FormLabel>
                                    <Input
                                        id="currentPassword"
                                        type="password"
                                        name="currentPassword"
                                        value={formData.currentPassword}
                                        onChange={handleChange}
                                        placeholder="Zadejte své aktuální heslo."
                                    />
                                    <FormErrorMessage>{errors.currentPassword}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.password} mb={4}>
                                    <FormLabel htmlFor="newPassword">{"Nové heslo"}</FormLabel>
                                    <Input
                                        id={fieldNameAndLabels.password.name}
                                        type="password"
                                        name={fieldNameAndLabels.password.name}
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="Zadejte své nové heslo."
                                    />
                                    <FormErrorMessage>{errors.password}</FormErrorMessage>
                                </FormControl>

                                <FormControl isInvalid={errors.confirmPassword} mb={4}>
                                    <FormLabel htmlFor="confirmPassword">{"Potvrzení nového hesla"}</FormLabel>
                                    <Input
                                        id="confirmPassword"
                                        type="password"
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        placeholder="Potvrďte své nové heslo."
                                    />
                                    <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
                                </FormControl>

                                <Button colorScheme="pink" type="submit">
                                    {"Změnit heslo"}
                                </Button>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            </ScreenContainer>
            <Footer />
        </Box>
    );
}
